import React, { useState } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'María Florencia Sánchez',
  time: 'Hace 5 meses',
  text: 'Increíble desde la recepción hasta los resultados. Fui a hacerme perfilado de cejas y las chicas me atendieron con mucha amabilidad, te reciben con algo para tomar, luego en la atención escuchan tus preferencias y te asesoran muy bien. Te explican todo lo que van haciendo y te van consultando todo para ver si estas conforme. Quedé más que conforme, 10/10✨.'
}, {
  name: 'Pamela Colusso',
  time: 'Hace 3 días',
  text: 'Siempre es un placer ir a ese espacio tan cálido. Iara y su hermana son un amor, y súper perfeccionistas!! 100% recomendables!.'
}, {
  name: 'Ana Sottile',
  time: 'Hace un año',
  text: 'La mejor!! Atención un mil.'
}];
const StarRating = () => <div className="flex gap-1 mb-4" data-id="element-206">
    {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-[#F0D060]" fill="currentColor" viewBox="0 0 20 20" data-id="element-207">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-208" />
      </svg>)}
  </div>;
const TRUNCATE_LENGTH = 80;
function TestimonialText({
  text
}: {
  text: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const needsTruncation = text.length > TRUNCATE_LENGTH;
  const displayText = !expanded && needsTruncation ? text.slice(0, TRUNCATE_LENGTH).trimEnd() + '...' : text;
  return <div className="text-[#5C3D2E] font-light leading-relaxed mb-8 flex-grow italic" data-id="element-209">
      <span data-id="element-210">"{displayText}"</span>
      {needsTruncation && <button onClick={() => setExpanded(!expanded)} className="ml-1 text-[#C9956A] not-italic font-medium text-sm hover:underline transition-colors" data-id="element-211">
          {expanded ? 'ver menos' : 'ver más...'}
        </button>}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full py-24 bg-[var(--warm-cream)]" data-id="element-212">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-215">
            <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A] mb-4" data-id="element-216">
              Testimonios
            </h2>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810]" data-id="element-217">
              Lo que dicen nuestras clientas
            </h3>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-218">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-gray-100 flex flex-col h-full" data-id="element-219">
              <StarRating data-id="element-220" />
              <TestimonialText text={testimonial.text} data-id="element-221" />
              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-222">
                <div className="w-10 h-10 rounded-full bg-[#FDF6F0] flex items-center justify-center text-[#C9956A] font-serif text-xl border border-[#D4AF37]/30" data-id="element-223">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-224">
                  <h4 className="font-medium text-[#2C1810] text-sm" data-id="element-225">
                    {testimonial.name}
                  </h4>
                  <span className="text-xs text-gray-500" data-id="element-226">
                    {testimonial.time}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}